/*  Websocket methods that use a "native" websocket (situated on App.vue) which can be passed down as a prop */
import { store } from '@/store';
import { computed } from 'vue';
const this_id = computed(() => store.state.presentation_device_id);
const current_patient = computed(() => store.state.presentation_current_patient);

export default {

    /**
     * Handler for different websocket messages towards the client.
     * @param {WebSocket} ws - Web socket to send replies on
     * @param {string} message - Message that was received
     */
    handleAllMessages(ws, message) {
        let msg_d = JSON.parse(message.data);
        switch(msg_d.codeword) {

            // On connection of another client (important for MTBConfig):
            case 'connect':
                if (msg_d.message != undefined && msg_d.message === 'ACK')
                    console.log('Verified WebSocket connection with server.')
                else
                    console.log(`Another instance connected to the WebSocket server: ${msg_d.id ? msg_d.id : 'unknown ID'}`);
                break;
            // Answer to keep-alive:
            case 'report-alive':
                ws?.send(JSON.stringify({codeword: 'report-alive', id: this_id.value}));
                break;
            // Update registered devices:
            case 'adapt-registered-devices':
                store.dispatch('setPresentationRegisteredDevices', msg_d.devices);
                store.dispatch('setPresentationDeviceID', msg_d.your_device);
                break;
            // If another device queries the current patient:
            case 'give-current-patient-id':
                if (current_patient.value !== undefined && current_patient.value != {})
                    ws?.send(JSON.stringify({codeword: 'adapt-current-patient-id', id: current_patient.value.id}));
                    break;
            // If another device sends the current patient:
            case 'adapt-current-patient-id':
                console.log(`Adapting patient ID ${msg_d.id}`);
                store.dispatch('setPresentationPatientByID', {patient_id: msg_d.id});
                break;
            // If this device gets told to show page X
            case 'show':
                if (msg_d.device == this_id.value) {    
                    store.dispatch('setPresentationSlide', msg_d.slide.toString());
                    ws?.send(JSON.stringify({codeword: 'im-showing', showing: store.getters.presentation_getpagetitle}));
                }
                break;
            // Tell particular device to scroll/flip table page/whatever forwards
            case 'next':
                if (msg_d.device == this_id.value) {
                    if (store.getters.presentation_getpagetitle == 'Variants') {
                        store.dispatch('performPresentationFlipForward', true);
                    } else {
                        window.scrollBy(0,200);
                    }
                }
                break;
            // Tell particular device to scroll/flip table page/whatever backwards
            case 'prev':
                if (msg_d.device == this_id.value) {
                    if (store.getters.presentation_getpagetitle == 'Variants') {
                        store.dispatch('performPresentationFlipBackward', true);
                    } else {
                        window.scrollBy(0,-200);
                    }
                }
                break;
                
        }
    },

    
}